import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as actions from './aircraft-event.actions';
import * as aircraftEventQuery from './aircraft-event.selectors';

@Injectable()
export class AircraftEventFacade {
  aircraftEventSkeletonsLoading$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventSkeletonsLoading)
  );
  aircraftEventSkeletonsLoaded$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventSkeletonsLoaded)
  );
  aircraftEventSkeletons$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventAuditSkeletons)
  );

  aircraftEventAuditLoading$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventAuditLoading)
  );
  aircraftEventAuditLoaded$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventAuditLoaded)
  );
  aircraftEventAudits$ = this.store.pipe(select(aircraftEventQuery.getAircraftEventAudits));

  aircraftEventBusinessPersonAuditLoading$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventBusinessPersonAuditLoading)
  );
  aircraftEventBusinessPersonAuditLoaded$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventBusinessPersonAuditLoaded)
  );
  aircraftEventBusinessPersonAudits$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventBusinessPersonAudits)
  );

  scheduledEventAuditLoading$ = this.store.pipe(
    select(aircraftEventQuery.getScheduledEventAuditLoading)
  );
  scheduledEventAuditLoaded$ = this.store.pipe(
    select(aircraftEventQuery.getScheduledEventAuditLoaded)
  );
  scheduledEventAudits$ = this.store.pipe(select(aircraftEventQuery.getScheduledEventAudits));

  aircraftEventTypesLoading$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventTypesLoading)
  );
  aircraftEventTypesLoaded$ = this.store.pipe(
    select(aircraftEventQuery.getAircraftEventTypesLoaded)
  );
  aircraftEventTypes$ = this.store.pipe(select(aircraftEventQuery.getAircraftEventTypes));

  flightBusinessPersonTypesLoading$ = this.store.pipe(
    select(aircraftEventQuery.getFlightBusinessPersonTypesLoaded)
  );
  flightBusinessPersonTypesLoaded$ = this.store.pipe(
    select(aircraftEventQuery.getFlightBusinessPersonTypesLoaded)
  );
  flightBusinessPersonTypes$ = this.store.pipe(
    select(aircraftEventQuery.getFlightBusinessPersonTypes)
  );

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadAircraftEvents() {
    this.store.dispatch(actions.ResetAircraftEvent());
    this.store.dispatch(actions.LoadAircraftEventSkeletons());
    this.store.dispatch(actions.LoadAircraftEventTypes());
    this.store.dispatch(actions.LoadFlightBusinessPersonTypes());
  }

  loadAircraftEventAudits(aircraftEventId: number) {
    this.store.dispatch(actions.LoadAircraftEventAudit({ aircraftEventId }));
  }

  nextPageAircraftEventAudits(aircraftEventId: number) {
    this.store.dispatch(actions.LoadNextPageAircraftEventAudit({ aircraftEventId }));
  }

  loadAircraftEventBusinessPersonAudits(aircraftEventBusinessPersonId: number) {
    this.store.dispatch(
      actions.LoadAircraftEventBusinessPersonAudit({ aircraftEventBusinessPersonId })
    );
  }

  nextPageAircraftEventBusinessPersonAudits(aircraftEventBusinessPersonId: number) {
    this.store.dispatch(
      actions.LoadNextPageAircraftEventBusinessPersonAudit({ aircraftEventBusinessPersonId })
    );
  }

  loadScheduledEventAudits(scheduledEventId: number) {
    this.store.dispatch(actions.LoadScheduledEventAudit({ scheduledEventId }));
  }

  nextPageScheduledEventAudits(scheduledEventId: number) {
    this.store.dispatch(actions.LoadNextPageScheduledEventAudit({ scheduledEventId }));
  }
}
